import { axios } from '../../plugins/axios'

export default {
    namespaced: true,

    state: {
        marcas: [],
    },

    getters: {
        getMarcas: state => {
            return state.marcas
        },
    },

    mutations: {
        SET_MARCAS(state, marcas) {
            state.marcas = marcas
        },
    },

    actions: {
        fetchMarcas: async function({ commit }) {
            await axios
                .get('/EonCloud/marcas')
                .then(response => {
                    commit('SET_MARCAS', response.data.data)
                })
                .catch(error => console.log(error))
        },
    },
}
